import { AuthPage as AntdAuthPage, AuthProps } from "@refinedev/antd";
import { useRouterContext } from "@refinedev/core";
import { BUILD_INFO } from "../../buildInfo";

const authWrapperProps = {
  style: { background: `rgb(255 255 255)` },
};

const renderAuthContent = (content: React.ReactNode) => {
  const { Link } = useRouterContext();

  return (
    <div
      style={{
        maxWidth: 500,
        textAlign: "center",
        margin: "0 auto",
      }}
    >
      <Link to="/">
        <img
          style={{ margin: "20px auto" }}
          src="/images/logo.png"
          alt="Logo"
          width="30%"
        />
      </Link>
      {content}
      <div
        style={{
          marginTop: "20px",
          fontSize: "11px",
          color: "#999",
          fontFamily: "monospace",
        }}
        title={BUILD_INFO.feature}
      >
        v{BUILD_INFO.version} ({BUILD_INFO.timestamp})
      </div>
    </div>
  );
};

export const AuthPage: React.FC<AuthProps> = (props) => {
  return (
    <AntdAuthPage
      wrapperProps={authWrapperProps}
      renderContent={renderAuthContent}
      {...props}
    />
  );
};
